module.exports = __webpack_public_path__ + "fonts/ttnorms-medium-webfont.d58e7dc0.woff";